// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.web.region.handler.RentalGrowthRegionAutocompleteWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalGrowthRegionAutocompleteWebApiHandler_autocomplete,
  RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_Path,
} from '@zg-rentals/ts-rental-growth-api-client';

import type {
  AutocompleteRegionRequestDto,
  AutocompleteRegionResponseDto,
} from '@zg-rentals/ts-rental-growth-api-client';

export type RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_Options = UseQueryOptions<
  AutocompleteRegionResponseDto,
  unknown,
  AutocompleteRegionResponseDto,
  readonly [string, AutocompleteRegionRequestDto]
>;

const RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_GetKey = (postData: AutocompleteRegionRequestDto) =>
  [RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_Path, postData] as const;

export const RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_queryOptions = (
  postData: AutocompleteRegionRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_GetKey(postData),
    queryFn: () => RentalGrowthRegionAutocompleteWebApiHandler_autocomplete(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useRentalGrowthRegionAutocompleteWebApiHandler_autocomplete = (
  postData: AutocompleteRegionRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalGrowthRegionAutocompleteWebApiHandler_autocomplete.getKey =
  RentalGrowthRegionAutocompleteWebApiHandler_autocomplete_GetKey;
